// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../node_modules/css-loader/index.js??ref--5-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--5-2!./all.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../../node_modules/vue-style-loader/lib/addStylesClient.js")("32739e9a", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/vendor/fontawesome-6.6.0/css/all.css
// module id = yKvD
// module chunks = 2